export const environment = {
  production: true,
  baseUrl: window.location.origin,
  cdn: 'https://cdn.adloop.co',
  homeUrl: 'https://signin.adloop.co',
  wsUrl: 'wss://'+window.location.host+'/websocket',
  timeout: 30000,
  stripeTestPubKey: 'pk_test_51JX69bF4Tz7N4hWwoOg0AYsMnTwgE0LSYZkzJR9hCLcAkE5pLrbObLdWw5WOAsYUEbaksekED9RZ6ADiJBOF5g5b00ZdRL9C33',
  stripeLivePubKey: 'pk_live_51JX69bF4Tz7N4hWwx6PphN41fthPO8ymk7SIHXBuhkiTXmRH46IzgURI66CTiIIAFo9kBmAGs6tJccYCQa4Oidus0026tuAYtr'
};